<template>
  <div class="cr-contianer">
    <div class="title">{{ getTitle() }}</div>
    <div style="height: 100%;position: relative;">
      <div
        v-if="crmType == ''"
        class="cr-body-side">
        <div
          v-for="(item, index) in leftSides"
          :key="index"
          :class="leftType===item.type? 'side-item-select' : 'side-item-default'"
          class="side-item"
          @click="sideClick(item)">{{ item.name }}</div>
      </div>
      <div :style="{ 'padding-left': crmType == '' ? '150px' : '0'}">
        <crm-relative-table
          v-for="(item, index) in leftSides"
          v-show="item.type == leftType"
          :key="index"
          :ref="'crm'+item.type"
          :show="show && item.type == leftType"
          :radio="radio"
          :crm-type="item.type"
          :selected-data="currentSelectedData"
          :action="action"
          @changeCheckout="checkCrmTypeInfos"/>
      </div>
    </div>
    <div class="handle-bar">
      <el-button @click.native="closeView">取消</el-button>
      <el-button
        type="primary"
        @click.native="confirmClick">確定</el-button>
    </div>
  </div>
</template>

<script type="text/javascript">
import CrmRelativeTable from './CrmRelativeTable'
import { objDeepCopy } from '@/utils'

export default {
  name: 'CrmRelatieve', // 相關
  components: {
    CrmRelativeTable
  },
  props: {
    /** 多選框 只能選一個 */
    radio: {
      type: Boolean,
      default: true
    },
    /** 沒有值就是全部型別 有值就是當個型別 */
    crmType: {
      type: String,
      default: ''
    },
    /** 需要展示哪些型別 預設關鍵字陣列 */
    showTypes: {
      type: Array,
      default: () => {
        return [
          'customer',
          'contacts',
          'leads',
          'business',
          'contract',
          'product'
        ]
      }
    },
    /** 已選資訊 */
    selectedData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    /** true 的時候 發請求 */
    show: {
      type: Boolean,
      default: true
    },
    /**
     * default 預設  condition 固定條件篩選
     * relative: 相關 新增
     */
    action: {
      type: Object,
      default: () => {
        return {
          type: 'default',
          data: {}
        }
      }
    }
  },
  data() {
    return {
      leftType: 'customer',
      leftSides: [],
      /** 各型別選擇的值 */
      currentSelectedData: {}
    }
  },
  computed: {},
  watch: {
    selectedData: function(data) {
      this.currentSelectedData = objDeepCopy(data)
    },
    // 重新整理標記
    show(val) {
      if (val) {
        this.currentSelectedData = objDeepCopy(this.selectedData)
      }
    }
  },
  mounted() {
    var leftItems = {
      customer: {
        name: '客戶',
        type: 'customer'
      },
      contacts: {
        name: '聯繫人',
        type: 'contacts'
      },
      leads: {
        name: '線索',
        type: 'leads'
      },
      business: {
        name: '商機',
        type: 'business'
      },
      contract: {
        name: '合同',
        type: 'contract'
      },
      product: {
        name: '產品',
        type: 'product'
      }
    }
    if (this.crmType) {
      this.leftType = this.crmType
      this.leftSides.push(leftItems[this.crmType])
    } else {
      for (let index = 0; index < this.showTypes.length; index++) {
        const element = this.showTypes[index]
        this.leftSides.push(leftItems[element])
      }
    }
    this.currentSelectedData = objDeepCopy(this.selectedData)
  },
  methods: {
    /**
     * 重新整理列表
     */
    refreshList() {
      this.$refs['crm' + this.crmType][0].refreshList()
    },

    sideClick(item) {
      this.leftType = item.type
    },
    clearAll() {
      if (this.crmType) {
        this.$refs['crm' + this.crmType][0].clearAll()
      }
    },
    // 	當用戶手動勾選全選 Checkbox 時觸發的事件
    selectAll() {},
    // 關閉操作
    closeView() {
      this.$emit('close')
    },
    checkCrmTypeInfos(data) {
      this.currentSelectedData[data.type] = data.data
    },
    // 確定選擇
    confirmClick() {
      if (this.crmType) {
        // 以單型別傳值
        this.$emit('changeCheckout', {
          data: this.currentSelectedData[this.crmType]
            ? this.currentSelectedData[this.crmType]
            : []
        })
      } else {
        this.$emit('changeCheckout', { data: this.currentSelectedData })
      }

      this.$emit('close')
    },
    // 根據型別獲取標題展示名稱
    getTitle() {
      if (this.crmType == 'leads') {
        return '關聯線索模組'
      } else if (this.crmType == 'customer') {
        return '關聯客戶模組'
      } else if (this.crmType == 'contacts') {
        return '關聯聯繫人模組'
      } else if (this.crmType == 'business') {
        return '關聯商機模組'
      } else if (this.crmType == 'product') {
        return '關聯產品模組'
      } else if (this.crmType == 'contract') {
        return '關聯合同模組'
      } else {
        return '關聯業務模組'
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.cr-contianer {
  height: 450px;
  position: relative;
  padding: 50px 0 50px 0;
}

.title {
  padding: 0 20px;
  font-size: 16px;
  line-height: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3;
  border-bottom: 1px solid $xr-border-line-color;
}

.handle-bar {
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  button {
    float: right;
    margin-top: 10px;
    margin-right: 10px;
  }
}

.cr-body-side {
  flex-shrink: 0;
  z-index: 3;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 150px;
  font-size: 12px;
  background-color: white;
  height: 100%;
  border-right: 1px solid $xr-border-line-color;
  .side-item {
    height: 35px;
    line-height: 35px;
    padding: 0 20px;
    cursor: pointer;
  }
}

.side-item-default {
  color: #333;
}

.side-item-select {
  color: #409eff;
  background-color: #ecf5ff;
}
</style>
